export * from './IconFavoriteStroked';
